/**
 * @param {string} key - Name of the key, e.g. 'Escape', 'Enter'.
 * @param {Function} actionFn - Function to call when the key is pressed.
 * @param {() => boolean} isEnabled - Function that returns whether the action is allowed to run.
 */
export function createKeyListener (key, actionFn, isEnabled) {
  return function (event) {
    if (event.key === key) {
      if (!isEnabled()) {
        event.preventDefault()
        return
      }
      actionFn()
    }
  }
}
